import type { SVGProps } from "react";

export type AlphaGameIconName =
  | "food"
  | "production"
  | "trade"
  | "science"
  | "culture"
  | "attack"
  | "guard"
  | "size"
  | "capacity"
  | "control"
  | "banner"
  | "land"
  | "commander"
  | "army"
  | "event"
  | "phase"
  | "help"
  | "inspect"
  | "deck"
  | "discard";

const PATHS: Readonly<Record<AlphaGameIconName, readonly string[]>> = {
  food: ["M12 3c4 3 6 6 6 10a6 6 0 1 1-12 0c0-4 2-7 6-10Z", "M12 8v10"],
  production: ["M4 20h16", "M6 20V9l6-5 6 5v11", "M9 20v-5h6v5"],
  trade: ["M4 8h13", "m13 4 4 4-4 4", "M20 16H7", "m11 12-4 4 4 4"],
  science: ["M9 3h6", "M10 3v6l-5 8a3 3 0 0 0 3 4h8a3 3 0 0 0 3-4l-5-8V3", "M8 16h8"],
  culture: ["M12 3 3 8l9 5 9-5-9-5Z", "M6 11v5c3 3 9 3 12 0v-5", "M21 9v6"],
  attack: ["m4 20 13-13", "m12 7 5-1-1 5", "m7 12-1 5 5-1"],
  guard: ["M12 3 20 6v6c0 5-3 8-8 10-5-2-8-5-8-10V6l8-3Z", "m8 12 3 3 5-6"],
  size: ["M5 5h14v14H5z", "M8 8h8v8H8z"],
  capacity: ["M4 19V9", "M8 19V5", "M12 19v-8", "M16 19V4", "M20 19v-6"],
  control: ["M4 20 9 4l3 7 3-7 5 16", "M7 14h10"],
  banner: ["M6 21V3", "m7 4 11 3-5 4 5 4-11 2"],
  land: ["M3 18 8 9l4 5 3-4 6 8", "M3 20h18"],
  commander: ["M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z", "M5 21c1-5 3-8 7-8s6 3 7 8"],
  army: ["M5 20V9l7-5 7 5v11", "M9 20v-5h6v5", "M7 10h10"],
  event: ["M13 2 5 14h7l-1 8 8-13h-7l1-9Z"],
  phase: ["M12 3v9l6 3", "M21 12a9 9 0 1 1-3-6"],
  help: [
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    "M9.5 9a2.5 2.5 0 1 1 4.1 1.9c-1.1.9-1.6 1.4-1.6 3.1",
    "M12 17h.01",
  ],
  inspect: ["M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z", "m16 16 4 4", "M11 8v6", "M8 11h6"],
  deck: ["M6 5h12v15H6z", "M3 8h3v12h10", "M9 9h6M9 13h6"],
  discard: ["M5 7h14", "M9 7V4h6v3", "M8 10v7M12 10v7M16 10v7", "M6 7l1 14h10l1-14"],
};

export function AlphaGameIcon({
  name,
  label,
  className,
  ...props
}: { readonly name: AlphaGameIconName; readonly label?: string } & SVGProps<SVGSVGElement>) {
  const paths = PATHS[name];
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label === undefined ? undefined : "img"}
      aria-label={label}
      aria-hidden={label === undefined ? true : undefined}
      {...props}
    >
      {paths.map((d) => (
        <path d={d} key={d} />
      ))}
    </svg>
  );
}
